import { type RecType } from '@/defs/rec'
import { useCardsRec } from '@/hooks/useCardsRec'
import { cn } from '@/utils/commonUtil'
import { getRecAlternates, getRecName } from '@/utils/recUtil'

import { CardLink } from '../CardLink/CardLink'

import styles from './CardRecAlternateNames.module.scss'

type AlternateNameLinkProps = {
  className?: string
  rec: RecType
}

const AlternateNameLink = ({ className, rec }: AlternateNameLinkProps) => (
  <CardLink className={className} disableModal rec={rec}>
    {getRecName(rec)}
  </CardLink>
)

type Props = {
  rec: RecType
  variant?: 'stacked'
}

export const CardRecAlternateNames = ({ rec, variant }: Props) => {
  const { card, cardPartner, loading } = useCardsRec({ rec })

  if (loading || !card) return null

  const { flavorRecs, originalRec } = getRecAlternates({ card, cardPartner, rec })

  if (!flavorRecs && !originalRec) return null

  const title = `${originalRec ? 'Original Name' : `Alternate Name${(flavorRecs?.length || 0) > 1 ? 's' : ''}`}${variant !== 'stacked' ? ':' : ''}`

  return (
    <div className={cn(styles.container, { styles, variant })}>
      <h3 className={styles.title}>{title}</h3>
      <ul className={styles.links}>
        {originalRec ? (
          <li>
            <AlternateNameLink className={styles.link} rec={originalRec} />
          </li>
        ) : (
          !!flavorRecs?.length &&
          flavorRecs.map((rec, i) => (
            <li key={i}>
              <AlternateNameLink className={styles.link} rec={rec} />
              <>{i < flavorRecs.length - 1 && <span>, </span>}</>
            </li>
          ))
        )}
      </ul>
    </div>
  )
}
